'use client';

import { motion } from 'framer-motion';
import React from 'react';
import CaseStudies from './caseStudies';

const CaseStudiesClient = () => {
  return (
    <main className="from-card/0 via-background/10 to-background relative min-h-screen overflow-hidden bg-gradient-to-br">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="bg-primary/5 absolute top-1/4 right-1/4 h-64 w-64 rounded-full blur-3xl" />
        <div className="bg-secondary/5 absolute bottom-1/4 left-1/4 h-64 w-64 rounded-full blur-3xl" />
        <div className="bg-accent/5 absolute top-1/2 left-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl" />
      </div>

      <div className="relative container mx-auto px-4 pt-40 md:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-16 text-center"
        >
          <div className="from-foreground via-primary to-foreground mb-4 bg-gradient-to-r bg-clip-text text-4xl leading-tight font-bold text-transparent md:text-5xl lg:text-6xl xl:text-7xl">
            <span className="text-foreground">Case </span> Studies
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="text-muted-foreground antonio mx-auto max-w-2xl font-serif text-xl leading-relaxed sm:text-2xl md:max-w-3xl"
          >
            Real-world insights showcasing advanced AI solutions and
            cutting-edge implementations that drive business value.
          </motion.p>
        </motion.div>
      </div>
      <CaseStudies />
    </main>
  );
};

export default CaseStudiesClient;
